exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".toggle-checkbox[data-v-7b682c52]:checked{right:0;--border-opacity:1;border-color:#68d391;border-color:rgba(104,211,145,var(--border-opacity));right:0;border-color:#68d391}.toggle-checkbox:checked+.toggle-label[data-v-7b682c52]{--bg-opacity:1;background-color:#68d391;background-color:rgba(104,211,145,var(--bg-opacity));background-color:#68d391}", ""]);

// exports
